import { useState } from "react";
import ModalWindow from "../../../../Components/ModalWindow/ModalWindow.js";
import { AddToastNotification } from "../../../../Services/ToastNotification/ToastNotificationManager.js";
import ServerTypes from "../../../../Services/Data/ServerTypes.js";
import GroupRequests from "../../../../Services/Api/GroupRequets.ts";

const AddEditGroupModal = ({editData, hide}) => {
    const groupRequests = new GroupRequests();

    const [groupType, setGroupType] = useState(editData ? editData.serverType : 0);
    const [groupName, setGroupName] = useState(editData ? editData.name : "");

    const AddEditGroup = () => {
        if(groupName.length > 0)
        {
            if(editData)
                EditGroup();
            else
                AddGroup();
        }
        else {
            AddToastNotification("Grupa musi mieć nazwę!", 0)
        }
    }

    const AddGroup = () => {
        const data = {
            Name: groupName,
            ServerType: groupType
        }

        groupRequests.Add(data, () => {
            hide();
        });
    }

    const EditGroup = () => {
        const data = {
            Id: editData.id,
            Name: groupName,
        }

        groupRequests.Edit(data, () => {
            hide();
        });
    }

    return (
        <ModalWindow 
            title={editData ? "Edytuj grupę" : "Dodaj nową grupę"}
            buttons={[
                { Text: editData ? "Edytuj" : "Dodaj", onClick: () => AddEditGroup() }, 
                { Text: "Anuluj", className: "modalSecondaryBtn", onClick: () => hide()}
            ]}
            minWidth={"35%"}
            content={<>
                <div>
                    <div className="modalField">
                        <span className="pl-1">Nazwa Grupy</span>
                        <input value={groupName} onChange={(e) => setGroupName(e.target.value)} className="input" type="text"></input>
                    </div>
                    { editData == null &&
                        <div className="modalField">
                            <span className="pl-1">Typ Grupy</span>
                            <select value={groupType} onChange={(e) => { setGroupType(Number(e.target.value)); } }  className="input">
                                { ServerTypes.map((type) => (
                                    <option value={type.Id}>{type.Name}</option>
                                ))}
                            </select>
                        </div>
                    }
                </div>
            </>}
        />
    )
};

export default AddEditGroupModal;